import React from 'react'

export const LoadingContext = React.createContext({
  loadingCount: 0,
  incrementLoading: () => {},
  decrementLoading: () => {},
})
